import { hasLyrics } from "./lyrics";

// How many of the team's songs have lyrics. The percentage is rounded down, so
// 100% only ever means that every song has them.
export const lyricsProgress = (songs) => {
  const list = songs || [];
  const total = list.length;
  const withLyrics = list.filter(hasLyrics).length;
  return {
    total,
    withLyrics,
    missing: total - withLyrics,
    percent: total === 0 ? 0 : Math.floor((withLyrics / total) * 100),
  };
};

// Saving a song that had no lyrics and now has some fills a gap in the catalog
// (a brand new song with lyrics doesn't, so only an edit counts).
export const addedLyrics = (before, after) => hasLyrics(after) && !hasLyrics(before);

export const thanksMessage = (missing) =>
  missing > 0
    ? `Thank you for adding lyrics! ${missing} ${missing === 1 ? "song still needs" : "songs still need"} lyrics.`
    : "Thank you - every song in the catalog has lyrics now!";
